import React from 'react';
import { IconProps } from './icons.models';

const LockIcon: React.FC<IconProps> = ({
    width = 18,
    height = 18,
    className,
    onClick,
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 0C6.51601 0.00285226 4.50305 1.88498 4.5 4.2076V7.2C4.5 7.27945 4.75883 7.2 4.95 7.2H6.3C6.49117 7.2 6.57695 7.30757 6.57695 7.2V4.2076C6.57692 2.95631 7.66178 1.94197 9 1.94197C10.3382 1.94197 11.4231 2.95631 11.4231 4.2076V7.2C11.4231 7.37875 11.5088 7.2 11.7 7.2H13.05C13.2412 7.2 13.5 7.37875 13.5 7.2V4.2076C13.4969 1.88498 11.484 0.00285226 9 0Z" fill="#455A64" />
            <path d="M4.55288 7.19922H13.447C14.4704 7.19922 15.3 8.06266 15.3 9.12778V16.0706C15.3 17.1358 14.4704 17.9992 13.447 17.9992H4.55288C3.52954 17.9992 2.69995 17.1358 2.69995 16.0707V9.12781C2.69995 8.06266 3.52954 7.19922 4.55288 7.19922Z" fill="#FFC107" />
            <path d="M10.7999 11.5908C10.8041 10.6601 10.0016 9.90237 9.00754 9.89845C8.01344 9.89453 7.20415 10.6459 7.19997 11.5766C7.19706 12.22 7.58563 12.8087 8.20146 13.0941L7.92353 14.9142C7.89569 15.0985 8.03271 15.269 8.22958 15.2951C8.24625 15.2973 8.26309 15.2984 8.27993 15.2984H9.71994C9.91876 15.3003 10.0815 15.1509 10.0835 14.9647C10.0836 14.9478 10.0824 14.9309 10.0799 14.9142L9.80198 13.0941C10.4104 12.8088 10.7961 12.2278 10.7999 11.5908Z" fill="#455A64" />
        </svg>

    );
};

export default LockIcon;


